"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var _default = {
  // SFLY: 'SFLY',
  // TP: 'TP',
  context: {
    sfly: 'SFLYUS',
    tp: 'TPUS_NEW'
  },
  HOME_LINKS: {
    sfly: {
      name: 'Shutterfly home',
      url: '/',
      rank: -1,
      code: 0
    },
    tp: {
      name: 'Tiny Prints home',
      url: '/',
      rank: -1,
      code: 0
    }
  },
  hideCategories: ['120', '122', '93479', '93495', '93480', '1358077', '1358079', '1358080', '1091693', '70003', '60302', '1228805', '1287440', '1287411', '1287413', '60324', '60325', '60327', '60328', '60329', '60326', '60323', '60304', '60303', '93640', '90009', '93456', '93478', '60345', '1085197', '1086954', '1110551', '1121283', '1121284', '93489', '93511', '1422240', //Resp Dynamic Content 5
  '93706', //Treat
  '1191677', '1191678', '1211448', '1417168', '1189079', '1189087', '1189075', '1229245', '1119743', '1127973', '1092284', '1092285'],
  hideSubCategories: ['18970', '10014'],
  HOME_ID: '0_-1',
  permanentCategory: ['1085970']
};
exports.default = _default;